export default from './CookiesPolicy';



// WEBPACK FOOTER //
// ./fe/web-cigarhouse/src/js/components/CookiesPolicy/index.js